import { inject, Injectable } from '@angular/core';
import { ListingExportConfig } from '@portal/shared/types/listing.types';
import { ExportRow } from '@portal/shared/types/export.types';
import { TableData } from '@portal/shared/types/api-response.types';
import { TimezoneService } from 'src/app/services/utility/timezone.service';
import type { FieldOperationsListItem } from '../ui/field-operations.types';
import { mapFieldOperationToExportRows } from './field-operations-listing.export';

@Injectable()
export class FieldOperationsListingExportConfigService implements ListingExportConfig {
  private readonly timezoneService = inject(TimezoneService);

  readonly fileName = 'Export-FieldOperations';

  readonly mapData = (data: TableData<FieldOperationsListItem>): ExportRow[] =>
    data.data.flatMap(fieldOperation =>
      mapFieldOperationToExportRows(fieldOperation, date => this.timezoneService.formatLong(date))
    );
}
